import { combineReducers } from 'redux';
import ssrPage from './ssrPage';
import ssrItemsOptions from './ssrItemsOptions';
import orderActions, * as fromOrderActions from '../orderActions';

const returnService = combineReducers({
  ssrPage,
  ssrItemsOptions,
  ssrEligibility: orderActions('ssrEligibility'),
  ssrHrtv: orderActions('ssrHrtv'),
  ssrCreate: orderActions('ssrCreate'),
});

export default returnService;

export const getOrderId = (state: Object) =>
  state.ssrPage ? state.ssrPage.orderId : null;
export const getSsrPage = (state: Object) =>
  state.returnService ? state.returnService.ssrPage : null;
export const getPage = (state: Object) => getSsrPage(state).page;
export const getReturnsError = (state: Object) =>
  getSsrPage(state).ssrReturnsErrorMessage;
export const getSsrItemsOptions = (state: Object) =>
  state.returnService ? state.returnService.ssrItemsOptions : {};
export const getBannerError = (state: Object) =>
  state.returnService.ssrPage.showBannerError;
export const getSsrItemProps = (state: object, id: string) =>
  getSsrItemsOptions(state)[id];
export const getStatusErrorMessage = (state: Object, id: string) =>
  getSsrItemProps(state, id).statusCodes;
export const getReturnIds = (state: Object) =>
  getSsrItemsOptions(state).returnIds;
export const getSelectedIds = (state: Object) =>
  getSsrItemsOptions(state).selectedIds;
export const getEligibleIds = (state: Object) =>
  getSsrItemsOptions(state).eligibleIds;
export const getTotalBoxes = (state: Object) =>
  state.returnService.ssrItemsOptions.totalBoxes;
export const getSelectedBoxes = (state: Object) =>
  state.returnService.ssrItemsOptions.selectedBoxes;
export const getTotalWeight = (state: Object) =>
  state.returnService.ssrItemsOptions.totalWeight;

export const getReturnsErrorMessage = (state: Object, filter: string) =>
  fromOrderActions.getErrorMessage(state.returnService[filter]);
export const getReturnsIsFetching = (state: Object, filter: string) =>
  fromOrderActions.getIsFetching(state.returnService[filter]);
export const getReasonCodes = (state: Object, filter: string) =>
  fromOrderActions.getMappedData(state.returnService[filter]).reasonCodes;
export const getSsrItems = (state: Object, filter: string) =>
  fromOrderActions.getMappedData(state.returnService[filter]).ssrItems;
export const getHrtvItemPayload = (state: Object, filter: string) =>
  fromOrderActions.getMappedData(state.returnService[filter]).hrtvItemPayload;
